/*
 *###############################################################################
 *Module Name                   : ProductController.js                          #
 *Purpose of the Module         :                                               #
 *Description of the Module     :                                               #
 *Original Author               :  W M Shanika Chamodi                          #
 *Date                          : Wednesday, September 8th 2021, 2:11:27 pm     #
 *Copyright © 2021 myPOS Software Solution (pvt Ltd.)                           #
 *###############################################################################
 */
const getTaxDets = async () => {
  const authToken = localStorage.getItem("authToken")
  const ApiURL = window.Links.ApiURL
  var data = []
  var requestOptions = {
    method: "GET",
    headers: {
      "Authorization": `Bearer ${authToken}`
    },
    redirect: "follow",
  }
  await fetch(`${ApiURL}CustomerTax`, requestOptions)
    .then(response => response.json())
    .then(result => {
      data = result.data
    })
    .catch(error => console.log("error", error))
  return data
}

const getDSearchColumns = async (menuCode, Control) => {
  const ApiURL = window.Links.ApiURL
  const authToken = localStorage.getItem("authToken")
  var data = []
  var requestOptions = {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      "Authorization": `Bearer ${authToken}`
    },
    redirect: "follow",
  }
  await fetch(`${ApiURL}Common/dsearchcol/${menuCode}/${Control}`, requestOptions)
    .then((response) => response.json())
    .then(result => {
      data = result.data
    })
    .catch(error => console.log("error", error))
  return data
}

const getSupplierDets = async () => {
  const ApiURL = window.Links.ApiURL
  const authToken = localStorage.getItem("authToken")
  var data = []
  var requestOptions = {
    method: "GET",
    headers: {
      "Authorization": `Bearer ${authToken}`
    },
    redirect: "follow",
  }
  await fetch(`${ApiURL}Supplier/All`, requestOptions)
    .then(response => response.json())
    .then(result => {
      data = result.data
    })
    .catch(error => console.log("error", error))
  return data
}

const getLocationDets = async () => {
  const ApiURL = window.Links.ApiURL
  const authToken = localStorage.getItem("authToken")
  var data = []
  var requestOptions = {
    method: "GET",
    headers: {
      "Authorization": `Bearer ${authToken}`
    },
    redirect: "follow",
  }
  await fetch(`${ApiURL}Locations`, requestOptions)
    .then(response => response.json())
    .then(result => {
      data = result.data
    })
    .catch(error => console.log("error", error))
  return data
}


const getLocationsUserWise = async (userCode) => {
  const ApiURL = window.Links.ApiURL
  const authToken = localStorage.getItem("authToken")
  var data = []
  var requestOptions = {
    method: "GET",
    headers: {
      "Authorization": `Bearer ${authToken}`
    },
    redirect: "follow",
  }
  await fetch(`${ApiURL}Locations/user/${userCode}`, requestOptions)
    .then(response => response.json())
    .then(result => {
      data = result.data
    })
    .catch(error => console.log("error", error))
  return data
}


const getLocationDropdown = async () => {
  const ApiURL = window.Links.ApiURL
  const authToken = localStorage.getItem("authToken")
  var data = []
  var requestOptions = {
    method: "GET",
    headers: {
      "Authorization": `Bearer ${authToken}`
    },
    redirect: "follow",
  }
  await fetch(`${ApiURL}locations/selectf`, requestOptions)
    .then(response => response.json())
    .then(result => {
      data = result.data
    })
    .catch(error => console.log("error", error))
  return data
}


const AutoOrderCalculation = async (product, location) => {
  const ApiURL = window.Links.ApiURL
  const authToken = localStorage.getItem("authToken")
  var data = []
  var requestOptions = {
    method: "GET",
    headers: {
      "Authorization": `Bearer ${authToken}`
    },
    redirect: "follow",
  }
  await fetch(`${ApiURL}product/autoOrder/${product}/${location}`, requestOptions)
    .then(response => response.json())
    .then(result => {
      data = result.data
    })
    .catch(error => console.log("error", error))
  return data
}



const getPriceModeDets = async () => {
  const ApiURL = window.Links.ApiURL
  const authToken = localStorage.getItem("authToken")
  var data = []
  var requestOptions = {
    method: "GET",
    headers: {
      "Authorization": `Bearer ${authToken}`
    },
    redirect: "follow",
  }
  await fetch(`${ApiURL}PriceMode`, requestOptions)
    .then(response => response.json())
    .then(result => {
      data = result.data
    })
    .catch(error => console.log("error", error))
  return data
}

const setProductSave = async (
  image,
  strProductCode,
  strProductDesc,
  strProductPOSDesc,
  strProductTouchDesc,
  strStockCode,
  strVendorPLU,
  strUnit,
  strPurchase,
  strLanguage1,
  strLanguage2,
  strCasesize,
  dbCost,
  dbMarkup,
  dbSelling,
  dbPackPrice,
  dbAVGCost,
  dbFixedGP,
  dbCurrGP,
  dbMaxDicPer,
  dbrMaxDicAmt,
  dbMaxQtyAllow,
  blActive,
  blPosEnable,
  blPurchase,
  blOpen,
  blComposite,
  blWeighted,
  blExpiry,
  blDirectGRN,
  blSellingHo,
  blfastmoving,
  blRaw,
  blPromotions,
  blMultiplePrices,
  strReference1,
  strReference2,
  strReference3,
  strReference4,
  strReference5,
  TaxDet,
  BarcodeDet,
  SupplierDet,
  PriceDet,
  GroupDet,
  InventoryDet,
  AddNew,
  strCreateBy,
  strMenuCode,
  strLoggedCompany,
  strLoggedLocation,
  strReason,
  minusAllow,
  CombinationDet,
  batchEnable,
  varientEnable,
  variantPNG,
  allowExchange,
  priceCHanges,
  strReturnCode,
  emptyBottle,
  productionPOS,
  dbMinSell,
  multiplePriceList,
  allowCostZero,
  isCombineItem,
  selectedLocations,
  innerCaseSizesList,
  freeQtyList,
  shortExpiryDays
) => {


  var myHeaders = new Headers()
  const authToken = localStorage.getItem("authToken")
  myHeaders.append("Content-Type", "application/json",
    "Authorization", `Bearer ${authToken}`)

  var raw = JSON.stringify({
    AllowExchange: allowExchange,
    strProductCode: strProductCode,
    strProductDesc: strProductDesc,
    strProductPOSDesc: strProductPOSDesc,
    strProductBtnDesc: strProductTouchDesc,
    strStockCode: strStockCode,
    strVendorPLU: strVendorPLU,
    strUnit: strUnit,
    strPurchasingMode: strPurchase,
    strLanguage1: strLanguage1,
    strLanguage2: strLanguage2,
    dbCaseSize: parseFloat(strCasesize),
    dbCost: parseFloat(dbCost),
    dbMarkup: parseFloat(dbMarkup),
    dbSelling: parseFloat(dbSelling),
    dbPackPrice: parseFloat(dbPackPrice),
    dbAvgCost: parseFloat(dbAVGCost),
    dbFixGp: parseFloat(dbFixedGP),
    dbGP: parseFloat(dbCurrGP),
    dbMaxDisPer: parseFloat(dbMaxDicPer),
    dbMaxDisAmt: parseFloat(dbrMaxDicAmt),
    dbMaxQtyAllow: parseFloat(dbMaxQtyAllow),
    IsActive: blActive,
    IsPosEnable: blPosEnable,
    IsOrderActive: blPurchase,
    IsOpen: blOpen,
    IsBundle: blComposite,
    IsDecimal: blWeighted,
    IsExp: blExpiry,
    IsDirectGrn: blDirectGRN,
    dbHoPrice: blSellingHo,
    dbFastMove: blfastmoving,
    dbRawItem: blRaw,
    dbNoDisc: blPromotions,
    dbMp: blMultiplePrices,
    strRef1: strReference1,
    strRef2: strReference2,
    strRef3: strReference3,
    strRef4: strReference4,
    strRef5: strReference5,
    blAddNew: AddNew,
    strImagePath: image,
    TAXDETAILS: TaxDet,
    REFERENCEDETAILS: BarcodeDet,
    SUPPLIERDETAILS: SupplierDet,
    PRICEDETAILS: PriceDet,
    GROUPDETAILS: GroupDet,
    INVENTORYDETAILS: InventoryDet,
    VARIANTDETAILS: CombinationDet,
    strCreateBy: strCreateBy,
    strMenuCode: strMenuCode,
    strLoggedCompany: strLoggedCompany,
    strLoggedLocation: strLoggedLocation,
    strReason: strReason,
    isMinusAllow: minusAllow,
    VariantEnable: varientEnable,
    BatchEnable: batchEnable,
    strVariantPNG: variantPNG == null ? "" : variantPNG,
    blpriceChange: priceCHanges,
    strReturnProduct: strReturnCode,
    emptyBottle: emptyBottle ? 1 : 0,
    productionPOS: productionPOS ? 1 : 0,
    dbMinSell: parseFloat(dbMinSell),
    multiplePriceList: multiplePriceList,
    allowCostZero: allowCostZero,
    isCombineItem: isCombineItem,
    selectedLocations: selectedLocations,
    innerCaseSizesList: innerCaseSizesList,
    freeQtyList: freeQtyList,
    shortExpiryDays: parseInt(shortExpiryDays)
  })


  const ApiURL = window.Links.ApiURL
  var requestOptions = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      "Authorization": `Bearer ${authToken}`
    },
    body: raw,
    redirect: "follow",
  }
  var data = [];
  await fetch(`${ApiURL}Product`, requestOptions)
    .then(response => data = response)
    .catch(error => console.log('error', error))
  return data;
}

//Upload Excel Value to Temp Table
const setProductTempSave = async (
  tempProduct
) => {
  var myHeaders = new Headers()
  const authToken = localStorage.getItem("authToken")
  myHeaders.append("Content-Type", "application/json",
    "Authorization", `Bearer ${authToken}`)

  var raw = JSON.stringify({
    tempProduct
  })

  const ApiURL = window.Links.ApiURL
  var requestOptions = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      "Authorization": `Bearer ${authToken}`
    },
    body: raw,
    redirect: "follow",
  }
  var data = [];
  await fetch(`${ApiURL}Product/excel`, requestOptions)
    .then(response => data = response)
    .catch(error => console.log('error', error))
  return data;
}

const getUploadValidation = async (id) => {
  const ApiURL = window.Links.ApiURL
  const authToken = localStorage.getItem("authToken")
  var data = []
  var requestOptions = {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      "Authorization": `Bearer ${authToken}`
    },
    redirect: "follow",
  }
  await fetch(`${ApiURL}Product/excel/${id}`, requestOptions)
    .then((response) => response.json())
    .then(result => {
      data = result

    })
    .catch(error => console.log("error", error))
  return data
}

const getProductDetailsCode = async (id, locationCode, LogUserType) => {
  const ApiURL = window.Links.ApiURL
  const authToken = localStorage.getItem("authToken")
  var data = []
  var requestOptions = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      "Authorization": `Bearer ${authToken}`
    },
    body: JSON.stringify({
      product: id,
      location: locationCode,
      user: LogUserType
    }),
  }
  await fetch(`${ApiURL}Product/getProduct`, requestOptions)
    .then((response) => response.json())
    .then(result => {
      data = result.data
    })
    .catch(error => console.log("error", error))
  return data
}

const getProcuctSummary = async () => {
  const ApiURL = window.Links.ApiURL
  const authToken = localStorage.getItem("authToken")
  var data = []
  var requestOptions = {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      "Authorization": `Bearer ${authToken}`
    },
    redirect: "follow",
  }
  await fetch(`${ApiURL}Product/`, requestOptions)
    .then(response => response.json())
    .then(result => {
      data = result.data
    })
    .catch(error => console.log("error", error))
  return data
}
const getUnitDetails = async () => {
  const ApiURL = window.Links.ApiURL
  const authToken = localStorage.getItem("authToken")
  var data = []
  var requestOptions = {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      "Authorization": `Bearer ${authToken}`
    },
    redirect: "follow",
  }
  await fetch(`${ApiURL}Unit/Select`, requestOptions)
    .then(response => response.json())
    .then(result => {
      data = result.data
    })
    .catch(error => console.log("error", error))
  return data
}

const getLanguageDetails = async () => {
  const ApiURL = window.Links.ApiURL
  const authToken = localStorage.getItem("authToken")
  var data = []
  var requestOptions = {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      "Authorization": `Bearer ${authToken}`
    },
    redirect: "follow",
  }
  await fetch(`${ApiURL}Language/Select`, requestOptions)
    .then(response => response.json())
    .then(result => {
      data = result.data
    })
    .catch(error => console.log("error", error))
  return data
}

const getPurchaseModeDetails = async () => {
  const ApiURL = window.Links.ApiURL
  const authToken = localStorage.getItem("authToken")
  var data = []
  var requestOptions = {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      "Authorization": `Bearer ${authToken}`
    },
    redirect: "follow",
  }
  await fetch(`${ApiURL}PurchaseModes/Select`, requestOptions)
    .then(response => response.json())
    .then(result => {
      data = result.data
    })
    .catch(error => console.log("error", error))
  return data
}

const getGroupDetails = async id => {
  const ApiURL = window.Links.ApiURL
  const authToken = localStorage.getItem("authToken")
  var data = []
  var requestOptions = {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      "Authorization": `Bearer ${authToken}`
    },
    redirect: "follow",
  }
  await fetch(`${ApiURL}GroupSetup/GroupNew/${id.code}`, requestOptions)
    .then(response => response.json())
    .then(result => {
      data = result.data
    })
    .catch(error => console.log("error", error))
  return data
}

const getGroupSetUpDetails = async () => {
  const authToken = localStorage.getItem("authToken")
  const ApiURL = window.Links.ApiURL
  var data = []
  var requestOptions = {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      "Authorization": `Bearer ${authToken}`
    },
    redirect: "follow",
  }
  await fetch(`${ApiURL}GroupSetup/All`, requestOptions)
    .then(response => response.json())
    .then(result => {
      data = result.data
      console.log(data)
    })
    .catch(error => console.log("error", error))
  return data
}

const getGroupSummary = async ProductCode => {
  const authToken = localStorage.getItem("authToken")
  const ApiURL = window.Links.ApiURL
  var data = []
  var requestOptions = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      "Authorization": `Bearer ${authToken}`
    },
    body: JSON.stringify({
      product: ProductCode,
    }),
    redirect: "follow",
  }
  await fetch(`${ApiURL}GroupSetup/ProductGroup/promaster`, requestOptions)
    .then(response => response.json())
    .then(result => {
      data = result.data

    })
    .catch(error => console.log("error", error))
  return data
}

const getProInventory = async (ProductCode, logUser) => {
  const ApiURL = window.Links.ApiURL
  const authToken = localStorage.getItem("authToken")
  var data = []
  var requestOptions = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      "Authorization": `Bearer ${authToken}`
    },
    body: JSON.stringify({
      product: ProductCode,
      user: logUser
    }),
    redirect: "follow",
  }
  await fetch(`${ApiURL}Product/Proinv`, requestOptions)
    .then(response => response.json())
    .then(result => {
      data = result.data
    })
    .catch(error => console.log("error", error))
  return data
}

const getCustomStrings = async () => {
  const ApiURL = window.Links.ApiURL
  const authToken = localStorage.getItem("authToken")
  var data = []
  var requestOptions = {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      "Authorization": `Bearer ${authToken}`
    },
    redirect: "follow",
  }
  await fetch(`${ApiURL}product/customString`, requestOptions)
    .then(response => response.json())
    .then(result => {
      data = result.data
    })
    .catch(error => console.log("error", error))
  return data
}

const getAvailableStock = async (product, user) => {
  const ApiURL = window.Links.ApiURL
  const authToken = localStorage.getItem("authToken")
  var data = []
  var requestOptions = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      "Authorization": `Bearer ${authToken}`
    },
    body: JSON.stringify({
      product: product,
      user: user
    }),
    redirect: "follow",
  }
  await fetch(`${ApiURL}product/availablestock`, requestOptions)
    .then(response => response.json())
    .then(result => {
      data = result.data
    })
    .catch(error => console.log("error", error))
  return data
}

const GetVarientImages = async () => {

  try {
    const ApiURL = window.Links.ApiURL;
    const authToken = localStorage.getItem("authToken");
    var data = []
    const requestOptions = {

      method: "GET",
      headers: {
        "Content-Type": "application/json",
        'Authorization': `Bearer ${authToken}`
      }

    };
    const response = await fetch(`${ApiURL}common/getVariants`, requestOptions);

    const result = await response.json();

    data = result.data;

    return data;

  } catch (error) {
    console.error("SaveSizeDetails error:", error);
  }

}



function getCommonName(array) {
  // Extract the names from the array
  const names = array.map(item => item.name);

  // Split each name into an array of words
  const nameArrays = names.map(name => name.split(' '));

  // Find the common prefix
  const commonPrefix = findCommonPrefix(nameArrays);

  // Join the common prefix words back into a string
  const commonName = commonPrefix.join(' ');

  return commonName;
}

function findCommonPrefix(arrays) {
  if (!arrays || arrays.length === 0) {
    return [];
  }

  const minLength = Math.min(...arrays.map(array => array.length));

  let commonPrefix = [];

  for (let i = 0; i < minLength; i++) {
    const firstWord = arrays[0][i];

    if (arrays.every(array => array[i] === firstWord)) {
      commonPrefix.push(firstWord);
    } else {
      break;
    }
  }

  return commonPrefix;
}


//***Upload excel file  */
export const handleUploadProducts = async (file, logUser, logLocation) => {
  const formData = new FormData();
  formData.append('excelFile', file);
  formData.append('user', logUser);
  formData.append('location', logLocation);

  const ApiURL = window.Links.ApiURL;
  const authToken = localStorage.getItem("authToken");

  try {
    const response = await fetch(`${ApiURL}product/upload`, {
      method: 'POST',
      body: formData,
      headers: {
        'Authorization': `Bearer ${authToken}`
      }
    });
    const data = await response.json();

    if (response.ok) {
      if (data.success == true) {
        return { success: true, successTable: JSON.parse(data.successTable), unsuccessTable: JSON.parse(data.unsuccessTable), msg: data.msg };
      } else {
        return { success: false, successTable: [], unsuccessTable: [], msg: data.msg };
      }
    } else {
      return { success: false, successTable: [], unsuccessTable: [], msg: data.msg };
    }
  } catch (error) {
    console.error('Error uploading file:', error);
    return { success: false, msg: 'Error uploading file' };
    // Handle errors
  }
};


const getCustomerTax = async (taxCode) => {

  try {
    const ApiURL = window.Links.ApiURL;
    const authToken = localStorage.getItem("authToken");

    const requestOptions = {

      method: "GET",
      headers: {
        "Content-Type": "application/json",
        'Authorization': `Bearer ${authToken}`
      }
    };

    const response = await fetch(`${ApiURL}CustomerTax/search/${taxCode}`, requestOptions);
    const result = await response.json();

    if (result.success == true) {
      return { success: true, data: result.data[0] };
    }

    return { success: false, data: {} };

  } catch (error) {
    console.error("SaveSizeDetails error:", error);
    return { success: false, data: {} };
  }

}


const getAllLocations = async () => {
  const ApiURL = window.Links.ApiURL;
  const authToken = localStorage.getItem("authToken");

  const requestOptions = {
    method: "GET",
    headers: {
      "Authorization": `Bearer ${authToken}`,
    },
    redirect: "follow",
  };

  try {
    const response = await fetch(`${ApiURL}Locations/select`, requestOptions);

    const result = await response.json();
    return result.data || []; // Return data if available, else return an empty array
  } catch (error) {
    console.error("Fetch error:", error);
    return []; // Return an empty array in case of an error
  }
};


const GetProductDefaultLocations = async () => {
  const ApiURL = window.Links.ApiURL;
  const authToken = localStorage.getItem("authToken");
  var obj = JSON.parse(localStorage.getItem("authUser"))

  if (obj == null || obj == undefined) return

  var LogUserType = obj[2]

  try {
    const response = await fetch(`${ApiURL}Product/getProductDefaultLocations`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "Authorization": `Bearer ${authToken}`
      },
      body: JSON.stringify({ user: LogUserType })
    });

    const responseData = await response.json();

    if (responseData.success) {
      return responseData.data
    }
    return []


  } catch (error) {
    console.log(error);
    return []
  }
}




export {
  getTaxDets,
  getLocationDets,
  getAllLocations,
  setProductSave,
  getProductDetailsCode,
  getProcuctSummary,
  getUnitDetails,
  getLanguageDetails,
  getPurchaseModeDetails,
  getGroupDetails,
  getSupplierDets,
  getPriceModeDets,
  getGroupSetUpDetails,
  getGroupSummary,
  getProInventory,
  getDSearchColumns,
  setProductTempSave,
  getUploadValidation,
  getCustomStrings,
  getAvailableStock,
  getLocationDropdown,
  AutoOrderCalculation,
  GetVarientImages,
  getCommonName,
  getLocationsUserWise,
  getCustomerTax,
  GetProductDefaultLocations
}